import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VForm, {
    ref: "formFrequency",
    model: {
      value: _vm.formIsValid,
      callback: function ($$v) {
        _vm.formIsValid = $$v;
      },
      expression: "formIsValid"
    }
  }, [_c(VRadioGroup, {
    attrs: {
      "direction": "horizontal",
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.internalModel.repeat,
      callback: function ($$v) {
        _vm.$set(_vm.internalModel, "repeat", _vm._n($$v));
      },
      expression: "internalModel.repeat"
    }
  }, [_c(VRow, _vm._l(_vm.frequencyOptions, function (freq) {
    return _c(VCol, {
      key: freq,
      attrs: {
        "cols": "3"
      }
    }, [_c(VRadio, {
      attrs: {
        "label": _vm.$i18n_t(`BackgroundJobs.ScheduledExports.dialog.frequency.${freq}`),
        "color": _vm.color,
        "value": freq
      }
    })], 1);
  }), 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "3"
    }
  }, [_c(VTextField, {
    staticClass: "ma-0",
    attrs: {
      "type": "number",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.month'),
      "disabled": _vm.disabledTimeInputs.includes('month'),
      "rules": _vm.requiredTimeRules['month'],
      "readonly": _vm.readonly,
      "clearable": !_vm.readonly
    },
    model: {
      value: _vm.internalModel.month,
      callback: function ($$v) {
        _vm.$set(_vm.internalModel, "month", _vm._n($$v));
      },
      expression: "internalModel.month"
    }
  })], 1), _vm.internalModel.repeat === 'weekly' ? _c(VCol, {
    attrs: {
      "cols": "3"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "items": _vm.daysList,
      "color": _vm.color,
      "label": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.weekDay'),
      "item-text": "dayText",
      "item-value": "dayId",
      "rules": _vm.requiredTimeRules['weekDay'],
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "readonly": _vm.readonly,
      "clearable": !_vm.readonly
    },
    model: {
      value: _vm.internalModel.weekDay,
      callback: function ($$v) {
        _vm.$set(_vm.internalModel, "weekDay", _vm._n($$v));
      },
      expression: "internalModel.weekDay"
    }
  })], 1) : _vm._e(), _vm.internalModel.repeat !== 'weekly' ? _c(VCol, {
    attrs: {
      "cols": "3"
    }
  }, [_c(VTextField, {
    staticClass: "ma-0",
    attrs: {
      "type": "number",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.day'),
      "disabled": _vm.disabledTimeInputs.includes('day'),
      "rules": _vm.requiredTimeRules['day'],
      "readonly": _vm.readonly,
      "clearable": !_vm.readonly
    },
    model: {
      value: _vm.internalModel.day,
      callback: function ($$v) {
        _vm.$set(_vm.internalModel, "day", _vm._n($$v));
      },
      expression: "internalModel.day"
    }
  })], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "3"
    }
  }, [_c(VTextField, {
    staticClass: "ma-0",
    attrs: {
      "type": "number",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.hour'),
      "disabled": _vm.disabledTimeInputs.includes('hour'),
      "rules": _vm.requiredTimeRules['hour'],
      "readonly": _vm.readonly,
      "clearable": !_vm.readonly
    },
    model: {
      value: _vm.internalModel.hour,
      callback: function ($$v) {
        _vm.$set(_vm.internalModel, "hour", _vm._n($$v));
      },
      expression: "internalModel.hour"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "3"
    }
  }, [_c(VTextField, {
    staticClass: "ma-0",
    attrs: {
      "type": "number",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.minute'),
      "disabled": _vm.disabledTimeInputs.includes('minute'),
      "rules": _vm.requiredTimeRules['minute'],
      "readonly": _vm.readonly,
      "clearable": !_vm.readonly
    },
    model: {
      value: _vm.internalModel.minute,
      callback: function ($$v) {
        _vm.$set(_vm.internalModel, "minute", _vm._n($$v));
      },
      expression: "internalModel.minute"
    }
  })], 1)], 1)], 1), _vm.nextExecutionTimes.length ? _c('core-n20-card', {
    staticClass: "dt-card-text-01 payload"
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.nextExecutions', {
    count: _vm.countNextExecutions
  })) + "\n    "), _vm._l(_vm.nextExecutionTimes, function (executionTime, index) {
    return _c('ul', {
      key: `nextExec${index}`
    }, [_c('li', [_vm._v(_vm._s(_vm.localizeDate(executionTime)))])]);
  })], 2) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };